import React, {Component} from 'react';
import StickButton from "../../../components/StickButton";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Select from"../../../local_node_modules/react-select"
import {deepCopyObject} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import SweetAlert from 'react-bootstrap-sweetalert';

class ReferenceModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			referenceModal: false,
			customerReferences: [],
			isMobile:window.innerWidth > 991 ? false : true
		};

		this.handleDelete = this.handleDelete.bind(this);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.props.customerReferences !== nextProps.customerReferences) {
			let customerReferences = deepCopyObject(nextProps.customerReferences);

			if (customerReferences && customerReferences.length === 0) {
				this.setState({
					customerReferences: [],
					partnerList: [],
					selectedMainPartner: null
				})
			} else {
				this.setState({
					customerReferences
				}, () => this.arrangePartnerList(this.state.selectedMainPartner));
			}
		}
	}

	async openReferenceModal() {
		let initialReferenceList = deepCopyObject(this.props.customerReferences);
		let rawPartners = deepCopyObject(this.props.partners);

		this.arrangeCustomerReferenceList();
		await this.arrangeMainPartnerList();


		if (initialReferenceList && initialReferenceList.length > 0) {
			let filtered = rawPartners.filter(rp => {
				let referencePartner = null;
				initialReferenceList.map(ir => {
					if (ir.partner.referencePartner === null) {
						referencePartner = ir.partner.recordId;
					}
				});
				return rp.recordId === referencePartner;
			});
			let selectedMainPartner = filtered && filtered[0];
			if (selectedMainPartner && selectedMainPartner.recordId) {
				this.arrangePartnerList(selectedMainPartner.recordId);
				this.setState({selectedMainPartner: selectedMainPartner.recordId})
			}
		}

		this.setState({
			initialReferenceList,
			referenceModal: true
		})
	}

	arrangeCustomerReferenceList() {
		let customerReferences = deepCopyObject(this.props.customerReferences);
		this.setState({customerReferences});
	}

	onPartnerChange(e) {
		this.setState({
			selectedPartner: e.value
		});
	}

	async onMainPartnerChange(e) {
		let selectedMainPartner = e.value;
		let rawPartners = deepCopyObject(this.props.partners);
		let mainPartner = rawPartners && rawPartners.filter(rp => {
			return rp.recordId === e.value
		});
		await this.props.addNewCustomerReference(mainPartner[0]);
		let customerReferences = deepCopyObject(this.props.customerReferences);
		this.arrangePartnerList(selectedMainPartner);
		this.setState({
			selectedMainPartner,
			customerReferences
		});
	}

	arrangeMainPartnerList() {
		let partners = deepCopyObject(this.props.partners)
		let mainPartnerList = [];

		partners && partners.map(p => {
			if (!p.referencePartner) {
				mainPartnerList.push(p)
			}
		});

		this.setState({mainPartnerList})
	}

	arrangePartnerList(selectedMainPartner) {
		let customerReferences = deepCopyObject(this.props.customerReferences);
		let rawPartners = deepCopyObject(this.props.partners);
		let partners = rawPartners.filter(rp => {
			return rp.referencePartner === selectedMainPartner
		});
		let partnerList = [];

		partners && partners.map(p => {
			let found = false;
			customerReferences && customerReferences.map(cr => {
				if (p.recordId === cr.partner.recordId) {
					found = true;
				}
			});
			if (!found) {
				partnerList.push(p);
			}
		});

		this.setState({
			partnerList
		});
	}

	async addNewCustomerReference() {
		let selectedPartner = deepCopyObject(this.state.selectedPartner);
		let selectedMainPartner = deepCopyObject(this.state.selectedMainPartner);
		let partners = deepCopyObject(this.props.partners);
		let newPartner = null;

		partners && partners.map(p => {
			if (p.recordId === selectedPartner) {
				newPartner = p;
			}
		});
		await this.props.addNewCustomerReference(newPartner);
		this.arrangeCustomerReferenceList();
		this.arrangePartnerList(selectedMainPartner);
		this.setState({selectedPartner: null})
	}

	showSelectedMainPartner() {
		let rawPartners = deepCopyObject(this.props.partners);
		let selectedMainPartner = deepCopyObject(this.state.selectedMainPartner);
		let mainPartnerToShow = rawPartners.filter(rp => {
			return rp.recordId === selectedMainPartner
		});
		return mainPartnerToShow[0].title;
	}

	prepareCustomerTitle(data) {
		if (!data.formattedName && !data.givenName && !data.familyName) {
			if (data.vknTckn) {
				return data.vknTckn;
			} else {
				return ' ';
			}
		}
		if (data.formattedName) {
			if (data.vknTckn) {
				return data.vknTckn + ' - ' + data.formattedName;
			} else {
				return data.formattedName;
			}
		} else {
			if (data.vknTckn) {
				let test = data.vknTckn + ' - ' + ((data.givenName ? data.givenName : ' ') + ' ' + (data.familyName ? data.familyName : ' '));
				return test;
			} else {
				return ' ';
			}
		}
	}

	handleDelete(row) {
		this.props.deleteCustomerReference(row)
	}

	changeMainPartner() {

		const confirm = () => {
			this.setState({
				customerReferences: [],
				partnerList: [],
				selectedMainPartner: null,
				alert: null
			}, () => this.props.clearCustomerReferences());
		};

		this.setState({
			alert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin misiniz?"
							onConfirm={() => confirm()}
							onCancel={() => this.setState({alert: null})}
				>
					{"Referans bilgileri sıfırlanacak."}
				</SweetAlert>
			)
		});
	}

	submitReferenceModal() {
		this.setState({referenceModal: false});
	}

	cancelReferenceModal() {
		let initialReferenceList = deepCopyObject(this.state.initialReferenceList);
		this.setState({referenceModal: false});
		this.props.setReferencesToInitialState(initialReferenceList);
	}

	render() {

		const columns = [
			{
				Header: "Unvan",
				title: "Unvan",
				accessor: "",
				sortable: false,
				Cell: row => row.partner.title !== null && (
					<TextOverFlowTooltip text={row.partner.title} maxLength={20}/>)
			},
			{
				Header: "Vkn/Tckn",
				title: "Vkn/Tckn",
				accessor: "",
				sortable: false,
				Cell: row => row.partner.vknTckn !== null && (
					<TextOverFlowTooltip text={row.partner.vknTckn} maxLength={20}/>)
			},
			{
				Header: "Ad Soyad",
				title: "Ad Soyad",
				accessor: "",
				sortable: false,
				Cell: row => row.partner.nameFamilyName !== null && (
					<TextOverFlowTooltip text={row.partner.nameFamilyName} maxLength={20}/>)
			},
			{
				Header: "Tarih",
				title: "Tarih",
				accessor: "",
				sortable: false,
				Cell: row => row.partner.partnershipStartDate !== null && (
					<TextOverFlowTooltip text={row.partner.partnershipStartDate} maxLength={20}/>)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				Cell: row => (
					<div>
						<button type="button" onClick={() => this.handleDelete(row)} rel="tooltip"
								className="btn btn-info btn-icon btn-sm"
								style={{margin: "0px", background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fas fa-trash-alt"></i>
						</button>
					</div>
				)
			}
		];

		const {isMobile} =this.state;
		return (
			<div>

				<div>{this.state.alert}</div>

				<div className={isMobile ? "" : "col-sm-12 row"}>
					<div className={isMobile ? "" : "col-sm-6 row"}>
						<StickButton position="leftSide"
									 label="Referans Bİlgİlerİ"
									 className="TekBtn referans"
									 disabled={this.props.fieldsDisabled}
									 onClick={() => this.openReferenceModal()}/>
					</div>
				</div>

				<Modal isOpen={this.state.referenceModal}>
					<ModalHeader toggle={() => this.cancelReferenceModal()}>Referans Bilgileri</ModalHeader>
					<ModalBody>
						<div>
							<div className='col-sm-12 row'>
								<div className='col-sm-3'>
									<label className='col-form-label'>Müşteri :</label>
								</div>
								<div className='col-sm-9'>
									<label className='col-form-label'>{this.prepareCustomerTitle(this.props.customerData)}</label>
								</div>
							</div>

							<div>
								<hr style={{margin: '0 0 10px 0'}}/>
							</div>

							<div className='col-sm-12 row'>
								{!this.state.selectedMainPartner &&
								<div className='col-sm-8'>
									<div>
										<label className='col-form-label'>Referans</label>
									</div>
									<div>
										<Select
											clearable={false}
											className="select-control"
											name="partner"
											id="tPartner"
											ref="tPartner"
											value={this.state.selectedMainPartner}
											placeholder="Seçiniz..."
											onChange={(e) => this.onMainPartnerChange(e)}
											options={this.state.mainPartnerList && this.state.mainPartnerList.map(p => ({
												value: p.recordId,
												label: p.title
											}))}
										/>
									</div>
								</div>}

								{this.state.selectedMainPartner &&
								<div className='col-sm-12 row'>
									<div className='col-sm-3'>
										<label className='col-form-label'>Referans :</label>
									</div>
									<div className='col-sm-5'>
										<label className='col-form-label'>{this.showSelectedMainPartner()}</label>
									</div>
									<div className='col-sm-4' >
										<button position="leftSide"
													 title="Değiştir"
													 label="Değiştir"
												style={{marginLeft:'7px'}}
													 className="TekBtn ekle"
												onClick={() => this.changeMainPartner()}>Ekle </button>
									</div>
								</div>}
							</div>

							<div className='col-sm-12 row'>
								<div className='col-sm-8'>
									<div>
										<label className='col-form-label'>Partner</label>
									</div>
									<div>
										<Select
											clearable={false}
											className="select-control"
											name="partner"
											id="tPartner"
											ref="tPartner"
											disabled={!this.state.selectedMainPartner}
											value={this.state.selectedPartner}
											placeholder="Seçiniz..."
											onChange={(e) => this.onPartnerChange(e)}
											options={this.state.partnerList && this.state.partnerList.map(p => ({
												value: p.recordId,
												label: p.title
											}))}
										/>
									</div>
								</div>

								<div className='col-sm-4' style={{padding: '20px 0 0 0'}}>
									<button position="leftSide"
												 title="Ekle"
												 label="Ekle"
												 disabled={!this.state.selectedPartner}
												 className="TekBtn ekle"
											onClick={() => this.addNewCustomerReference()}> Ekle </button>
								</div>
							</div>

							<div key={this.state.key} className='col-sm-12' style={{marginTop: '20px'}}>
								<Table
									columns={columns}
									content={this.state.customerReferences ? this.state.customerReferences : []}
									total={this.state.customerReferences && this.state.customerReferences.length}
									paginationEnabled={false}
								/>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<nav className="col-sm-12 row">
							<div className="col-3">
								<button position="leftSide"
											 label="İptal"
											 className="TekBtn vazgec"
											 style={{background: 'rgb(158, 158, 158)', padding:'9px 37px 9px 14px'}}
										onClick={() => this.cancelReferenceModal()}> İptal </button>
							</div>
							<div className="col-6"></div>
							<div className="col-3">
								<button position="rightSide"
											 label="Onayla"
											 className="TekBtn kaydet"
											 style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding:'9px 37px 9px 14px'}}
										onClick={() => this.submitReferenceModal()}> Onayla</button>
							</div>
						</nav>
					</ModalFooter>
				</Modal>
			</div>
		)
	}
}

export default ReferenceModal;